import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 0;
  background: #fff;
  top: 0;
  left: 0;
  right: 0;
  padding: 12px;

  .right {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    animation: slideIn 0.65s ease-out forwards;
    @-webkit-keyframes slideIn {
      100% {
        -webkit-transform: translateX(0%);
      }
    }
    @keyframes slideIn {
      100% {
        transform: translateX(0%);
      }
    }
  } 
`;
